import { BookOpenIcon, MoveIcon, DumbbellIcon, BrainIcon, UsersIcon, CalendarRangeIcon, ListChecksIcon, ZapIcon, SlidersHorizontalIcon, LayoutGridIcon, ClipboardListIcon, PackageOpenIcon, LayoutListIcon, PersonStandingIcon, ShuffleIcon, PlayIcon, TrendingUpIcon, TrendingDownIcon, EyeIcon, HandIcon, PuzzleIcon, MessageCircleIcon, TimerIcon, CalendarDaysIcon, RepeatIcon, LineChartIcon, ClockIcon, CalendarCheckIcon, TargetIcon, BriefcaseIcon, ShoppingCartIcon, DownloadIcon, SearchIcon, MousePointerClickIcon, GraduationCapIcon, ActivityIcon, MegaphoneIcon, Building2Icon, SunIcon, SproutIcon, BookmarkIcon, MonitorPlayIcon, StickyNoteIcon, TrophyIcon, HomeIcon, HandshakeIcon, MapPinIcon, type LucideIcon } from 'lucide-react';
export const CHECKOUT_URL = 'https://activa-tu-cuerpo.impultienda.ar/checkout';
export const OFFER_ANCHOR = '#oferta';
export const PRICE = '$19.990';
export const PRODUCT_NAME = 'REACTIVA TU CUERPO';
// IMPORTANTE: usá solo la cifra real de ventas registrada en tu tienda.
export const BUYERS_COUNT = '+2.500';
export const images = {
  mockup: 'https://cdn.magicpatterns.com/uploads/7kPcZuZ9oztgfiqPLS2Hmz/MOCK_UP.png',
  searching: 'https://cdn.magicpatterns.com/patterns/generated-images/070ad554-c840-49a3-a089-53de96069e28.jpg',
  group: 'https://cdn.magicpatterns.com/patterns/generated-images/c2530099-ac89-4fcc-9481-577d434f734c.jpg',
  balance: 'https://cdn.magicpatterns.com/patterns/generated-images/aba56f2b-af1a-4c10-9c5f-82123dcad642.jpg',
  planning: 'https://cdn.magicpatterns.com/patterns/generated-images/af6942cc-e92b-4b90-8bba-b9657ee94223.jpg',
  hero: 'https://cdn.magicpatterns.com/patterns/generated-images/6df30300-bd4f-4049-9ed7-6af7ae9a7a79.jpg'
};
export type PageVariant = 'exercise' | 'routine' | 'table' | 'checklist' | 'calendar' | 'planner' | 'cognitive' | 'group' | 'guide' | 'card';
export type Feature = {
  label: string;
  icon: LucideIcon;
};
export type Module = {
  number: number;
  title: string;
  shortTitle: string;
  description: string;
  features: Feature[];
  pages: {
    variant: PageVariant;
    title: string;
  }[];
  icon: LucideIcon;
  tone: string;
  cover: string;
};
export const moduleStages: {
  title: string;
  hint: string;
  modules: number[];
}[] = [{
  title: 'Entendé las bases',
  hint: 'Cómo pensar y organizar el trabajo',
  modules: [1]
}, {
  title: 'Trabajá cada capacidad',
  hint: 'Ejercicios y actividades por objetivo',
  modules: [2, 3, 4, 5]
}, {
  title: 'Planificá y aplicá',
  hint: 'Sesiones y programas listos',
  modules: [6, 7]
}];
export const modules: Module[] = [{
  number: 1,
  title: 'Fundamentos del entrenamiento',
  shortTitle: 'Fundamentos',
  description: 'Bases para comprender y organizar el trabajo con adultos mayores. Incluye conceptos prácticos, criterios de trabajo y herramientas para estructurar las sesiones.',
  features: [{
    label: 'Conceptos prácticos',
    icon: BookOpenIcon
  }, {
    label: 'Criterios de trabajo',
    icon: ListChecksIcon
  }, {
    label: 'Estructura de sesiones',
    icon: LayoutListIcon
  }],
  pages: [{
    variant: 'guide',
    title: 'Criterios de trabajo'
  }, {
    variant: 'checklist',
    title: 'Estructura'
  }],
  icon: BookOpenIcon,
  tone: 'bg-brand-800',
  cover: 'https://cdn.magicpatterns.com/uploads/4mkL7dJ64P7nyuozHpwgxj/WhatsApp_Image_2026-09-25_at_00.55.34.jpg'
}, {
  number: 2,
  title: 'Movilidad articular y movimiento',
  shortTitle: 'Movilidad',
  description: 'Ejercicios y propuestas para trabajar la movilidad de las principales articulaciones. Incluye ejercicios ilustrados, variantes y propuestas prácticas.',
  features: [{
    label: 'Ejercicios ilustrados',
    icon: PersonStandingIcon
  }, {
    label: 'Variantes',
    icon: ShuffleIcon
  }, {
    label: 'Propuestas prácticas',
    icon: PlayIcon
  }],
  pages: [{
    variant: 'exercise',
    title: 'Movilidad de hombros'
  }, {
    variant: 'card',
    title: 'Ficha de ejercicio'
  }],
  icon: MoveIcon,
  tone: 'bg-brand-600',
  cover: 'https://cdn.magicpatterns.com/uploads/tyoTKmmyGdDg8aVdS2CPGB/WhatsApp_Image_2026-09-25_at_00.57.57.jpg'
}, {
  number: 3,
  title: 'Fuerza, equilibrio y capacidad funcional',
  shortTitle: 'Fuerza y equilibrio',
  description: 'Recursos para trabajar fuerza, equilibrio, estabilidad, coordinación y movimientos funcionales. Incluye ejercicios, progresiones y regresiones.',
  features: [{
    label: 'Ejercicios',
    icon: DumbbellIcon
  }, {
    label: 'Progresiones',
    icon: TrendingUpIcon
  }, {
    label: 'Regresiones',
    icon: TrendingDownIcon
  }],
  pages: [{
    variant: 'routine',
    title: 'Progresiones'
  }, {
    variant: 'exercise',
    title: 'Equilibrio'
  }],
  icon: DumbbellIcon,
  tone: 'bg-brand-700',
  cover: 'https://cdn.magicpatterns.com/uploads/qioU4UUgb9nQk8cv5ABiyU/WhatsApp_Image_2026-09-25_at_00.55.34_(1).jpg'
}, {
  number: 4,
  title: 'Estimulación cognitiva + movimiento',
  shortTitle: 'Cognitivo + movimiento',
  description: 'Actividades que combinan movimiento con memoria, atención, coordinación y concentración. Ideal para generar sesiones más dinámicas y completas.',
  features: [{
    label: 'Memoria',
    icon: BrainIcon
  }, {
    label: 'Atención',
    icon: EyeIcon
  }, {
    label: 'Coordinación',
    icon: HandIcon
  }],
  pages: [{
    variant: 'cognitive',
    title: 'Memoria en movimiento'
  }, {
    variant: 'card',
    title: 'Actividad'
  }],
  icon: BrainIcon,
  tone: 'bg-brand-500',
  cover: 'https://cdn.magicpatterns.com/uploads/grmWVChVR5atGK5p1KUih4/WhatsApp_Image_2026-09-25_at_00.55.35.jpg'
}, {
  number: 5,
  title: 'Dinámicas y actividades grupales',
  shortTitle: 'Grupales',
  description: 'Juegos y actividades para clases, geriátricos, centros de día y grupos. Propuestas para fomentar movimiento, participación e interacción.',
  features: [{
    label: 'Juegos',
    icon: PuzzleIcon
  }, {
    label: 'Clases grupales',
    icon: UsersIcon
  }, {
    label: 'Interacción',
    icon: MessageCircleIcon
  }],
  pages: [{
    variant: 'group',
    title: 'Dinámica en ronda'
  }, {
    variant: 'guide',
    title: 'Juego grupal'
  }],
  icon: UsersIcon,
  tone: 'bg-brand-800',
  cover: 'https://cdn.magicpatterns.com/uploads/pNondKJpoRXkYVT5UbfXUj/WhatsApp_Image_2026-09-25_at_00.55.35_(1).jpg'
}, {
  number: 6,
  title: 'Planificación profesional',
  shortTitle: 'Planificación',
  description: 'Herramientas para organizar sesiones de 20, 30, 45 y 60 minutos. Incluye estructuras y planillas de planificación.',
  features: [{
    label: '20 · 30 · 45 · 60 min',
    icon: TimerIcon
  }, {
    label: 'Estructuras',
    icon: LayoutListIcon
  }, {
    label: 'Planillas',
    icon: ClipboardListIcon
  }],
  pages: [{
    variant: 'planner',
    title: 'Sesión de 45 min'
  }, {
    variant: 'table',
    title: 'Planilla semanal'
  }],
  icon: CalendarRangeIcon,
  tone: 'bg-brand-600',
  cover: 'https://cdn.magicpatterns.com/uploads/oWA7XFuwigqqdai7M7n3hq/WhatsApp_Image_2026-09-25_at_00.55.36.jpg'
}, {
  number: 7,
  title: 'Programas y rutinas listas para aplicar',
  shortTitle: 'Programas',
  description: 'Programas estructurados para organizar el trabajo durante 7, 14, 30 y 90 días. Incluye rutinas, estructuras de trabajo y herramientas de seguimiento.',
  features: [{
    label: '7 · 14 · 30 · 90 días',
    icon: CalendarDaysIcon
  }, {
    label: 'Rutinas',
    icon: RepeatIcon
  }, {
    label: 'Seguimiento',
    icon: LineChartIcon
  }],
  pages: [{
    variant: 'calendar',
    title: 'Programa 30 días'
  }, {
    variant: 'table',
    title: 'Seguimiento'
  }],
  icon: ListChecksIcon,
  tone: 'bg-brand-700',
  cover: 'https://cdn.magicpatterns.com/uploads/4nqDRYXhCLS3z87Nj92LQn/WhatsApp_Image_2026-09-25_at_00.55.36_(1).jpg'
}];
export const interiorPages: {
  label: string;
  variant: PageVariant;
}[] = [{
  label: 'Ejercicios ilustrados',
  variant: 'exercise'
}, {
  label: 'Rutinas',
  variant: 'routine'
}, {
  label: 'Planillas',
  variant: 'checklist'
}, {
  label: 'Tablas',
  variant: 'table'
}, {
  label: 'Actividades',
  variant: 'cognitive'
}, {
  label: 'Calendarios',
  variant: 'calendar'
}, {
  label: 'Fichas',
  variant: 'card'
}, {
  label: 'Guías',
  variant: 'guide'
}, {
  label: 'Ejemplos de sesiones',
  variant: 'planner'
}];
export type Bonus = {
  number: number;
  title: string;
  shortTitle: string;
  description: string;
  icon: LucideIcon;
  image: string;
  imageAlt: string;
  highlight?: string;
  points: string[];
};
export const bonuses: Bonus[] = [{
  number: 1,
  title: '50 sesiones express',
  shortTitle: 'Sesiones express',
  description: 'Sesiones estructuradas listas para consultar y utilizar como base de trabajo.',
  icon: ZapIcon,
  image: 'https://cdn.magicpatterns.com/uploads/sb797ETDqA2qoL4RPooqdn/mockup-bono-1-50-sesiones-express.png',
  imageAlt: 'Portada del Bono 1: 50 sesiones express',
  points: ['Sesiones estructuradas', 'Listas para consultar', 'Base de trabajo'],
  highlight: '50'
}, {
  number: 2,
  title: 'Adaptador de ejercicios',
  shortTitle: 'Adaptador',
  description: 'Guía práctica para adaptar actividades según diferentes niveles de capacidad.',
  icon: SlidersHorizontalIcon,
  image: 'https://cdn.magicpatterns.com/uploads/czD7XzxzFzFKSCpjvy7TUn/mockup-bono-2-adaptador-de-ejercicios.png',
  imageAlt: 'Portada del Bono 2: Adaptador de ejercicios',
  points: ['Adaptación por niveles', 'Guía práctica', 'Distintas capacidades']
}, {
  number: 3,
  title: 'Generador de clases grupales',
  shortTitle: 'Generador de clases',
  description: 'Sistema para organizar rápidamente clases según duración, objetivo, nivel y materiales disponibles.',
  icon: LayoutGridIcon,
  image: 'https://cdn.magicpatterns.com/uploads/k9b754mycY7QSmjUdTAsP9/mockup-bono-3-generador-de-clases-grupales.png',
  imageAlt: 'Portada del Bono 3: Generador de clases grupales',
  points: ['Por duración', 'Por objetivo y nivel', 'Según materiales']
}, {
  number: 4,
  title: 'Kit profesional para geriátricos y centros de día',
  shortTitle: 'Kit profesional',
  description: 'Planillas y recursos para organizar asistencia, objetivos, observaciones, seguimiento y evolución.',
  icon: ClipboardListIcon,
  image: 'https://cdn.magicpatterns.com/uploads/hM4AvN2cuUSddR4i8GqKkn/mockup-bono-4-kit-profesional-para-geriatricos-y-centros-de-dia.png',
  imageAlt: 'Portada del Bono 4: Kit profesional para geriátricos y centros de día',
  points: ['Asistencia y objetivos', 'Observaciones', 'Seguimiento y evolución']
}, {
  number: 5,
  title: '100 actividades sin equipamiento',
  shortTitle: 'Sin equipamiento',
  description: 'Banco de actividades de movilidad, fuerza, equilibrio, coordinación, memoria y recreación que requieren pocos o ningún material.',
  icon: PackageOpenIcon,
  image: 'https://cdn.magicpatterns.com/uploads/wA5AmyYJvxX1PTSWnao3Ks/mockup-bono-5-100-actividades-sin-equipamiento.png',
  imageAlt: 'Portada del Bono 5: 100 actividades sin equipamiento',
  points: ['Movilidad y fuerza', 'Equilibrio y coordinación', 'Memoria y recreación'],
  highlight: '100'
}];
export const searchHabits: Feature[] = [{
  label: 'Buscás ejercicios en Google.',
  icon: SearchIcon
}, {
  label: 'Guardás videos de Instagram.',
  icon: BookmarkIcon
}, {
  label: 'Mirás rutinas en YouTube.',
  icon: MonitorPlayIcon
}, {
  label: 'Anotás ideas.',
  icon: StickyNoteIcon
}, {
  label: 'Intentás adaptar actividades.',
  icon: ShuffleIcon
}, {
  label: 'Armás sesiones desde cero.',
  icon: RepeatIcon
}];
export const solutionPoints: string[] = ['Ahorrar tiempo buscando recursos.', 'Planificar con mayor estructura.', 'Contar con propuestas específicas para adultos mayores.', 'Variar tus sesiones.', 'Adaptar actividades según diferentes niveles.', 'Incorporar nuevas herramientas a tu práctica.', 'Ampliar los servicios que podés ofrecer.'];
export const growthPath: string[] = ['Aprendé', 'Preparate', 'Incorporá herramientas', 'Aplicá', "Ampliá tus oportunidades LABORALES y servicios"];
export const situations: {
  title: string;
  lead: string;
  body: string;
  highlight: string;
  icon: LucideIcon;
}[] = [];
export const applicationContexts: {
  title: string;
  description: string;
  icon: LucideIcon;
}[] = [{
  title: 'Centros de jubilados',
  description: 'Propuestas de movimiento, fuerza, equilibrio, coordinación y recreación para grupos de personas mayores.',
  icon: UsersIcon
}, {
  title: 'Geriátricos y residencias',
  description: 'Recursos para organizar actividades y sesiones adaptadas a diferentes capacidades.',
  icon: Building2Icon
}, {
  title: 'Centros de día',
  description: 'Propuestas individuales y grupales para trabajar diferentes capacidades físicas y cognitivas.',
  icon: SunIcon
}, {
  title: 'Clubes',
  description: 'Actividades y clases orientadas a personas mayores.',
  icon: TrophyIcon
}, {
  title: 'Gimnasios',
  description: 'Incorporá propuestas orientadas a adultos mayores dentro de los servicios que ofrecés.',
  icon: DumbbellIcon
}, {
  title: 'Trabajo a domicilio',
  description: 'Herramientas para organizar sesiones individuales y adaptar actividades.',
  icon: HomeIcon
}, {
  title: 'Programas y prestaciones vinculadas a obras sociales',
  description: 'Recursos que pueden aplicarse en propuestas y programas destinados a personas mayores, de acuerdo con los requisitos de cada cobertura o institución.',
  icon: HandshakeIcon
}, {
  title: 'Otros espacios profesionales',
  description: 'Aplicá las herramientas según tu formación y el contexto en el que desarrolles tu actividad.',
  icon: MapPinIcon
}];
export const benefits: Feature[] = [{
  label: 'Ahorrá tiempo buscando ejercicios.',
  icon: ClockIcon
}, {
  label: 'Organizá mejor tus sesiones.',
  icon: CalendarCheckIcon
}, {
  label: 'Tené recursos específicos para adultos mayores.',
  icon: TargetIcon
}, {
  label: 'Variá tus actividades.',
  icon: ShuffleIcon
}, {
  label: 'Prepará sesiones individuales o grupales.',
  icon: UsersIcon
}, {
  label: 'Adaptá propuestas según diferentes niveles de capacidad.',
  icon: SlidersHorizontalIcon
}, {
  label: 'Incorporá nuevas herramientas a tu práctica profesional.',
  icon: BriefcaseIcon
}, {
  label: 'Ampliá los servicios que podés ofrecer.',
  icon: TrendingUpIcon
}];
export const steps: Feature[] = [{
  label: 'Comprás',
  icon: ShoppingCartIcon
}, {
  label: 'Descargás',
  icon: DownloadIcon
}, {
  label: 'Buscás',
  icon: SearchIcon
}, {
  label: 'Elegís',
  icon: MousePointerClickIcon
}, {
  label: 'Aplicás',
  icon: PlayIcon
}];
export const audience: Feature[] = [{
  label: 'Profesores de Educación Física',
  icon: GraduationCapIcon
}, {
  label: 'Personal Trainers',
  icon: DumbbellIcon
}, {
  label: 'Kinesiólogos',
  icon: HandIcon
}, {
  label: 'Fisioterapeutas',
  icon: ActivityIcon
}, {
  label: 'Instructores',
  icon: MegaphoneIcon
}, {
  label: 'Entrenadores',
  icon: TimerIcon
}, {
  label: 'Profesionales de geriátricos',
  icon: Building2Icon
}, {
  label: 'Profesionales de centros de día',
  icon: SunIcon
}, {
  label: 'Personas que quieren empezar a trabajar con adultos mayores',
  icon: SproutIcon
}];
export const comparisonRows: {
  topic: string;
  before: string;
  after: string;
}[] = [{
  topic: 'Búsqueda',
  before: 'Horas buscando ejercicios',
  after: 'Biblioteca organizada'
}, {
  topic: 'Material',
  before: 'Videos guardados por todos lados',
  after: 'Ejercicios específicos'
}, {
  topic: 'Organización',
  before: 'Información desorganizada',
  after: 'Recursos por objetivo'
}, {
  topic: 'Actividades',
  before: 'Improvisar a último momento',
  after: 'Actividades listas para consultar'
}, {
  topic: 'Planificación',
  before: 'Empezar cada sesión desde cero',
  after: 'Rutinas y planificación'
}, {
  topic: 'Adaptación',
  before: 'Adaptar sin una guía',
  after: 'Herramientas para adaptar propuestas'
}, {
  topic: 'Servicios',
  before: 'Pocas propuestas para ofrecer',
  after: 'Más recursos para ampliar lo que podés ofrecer'
}];

// Ejemplos de muestra: reemplazalos por compras reales exportadas de tu tienda.
export const recentPurchases: {
  name: string;
  place: string;
  minutesAgo: number;
}[] = [{
  name: 'Martina G.',
  place: 'Córdoba',
  minutesAgo: 3
}, {
  name: 'Lucas F.',
  place: 'Rosario, Santa Fe',
  minutesAgo: 7
}, {
  name: 'Carolina P.',
  place: 'Mendoza',
  minutesAgo: 12
}, {
  name: 'Julián R.',
  place: 'La Plata, Buenos Aires',
  minutesAgo: 5
}, {
  name: 'Sofía M.',
  place: 'San Miguel de Tucumán',
  minutesAgo: 18
}, {
  name: 'Diego A.',
  place: 'Mar del Plata, Buenos Aires',
  minutesAgo: 9
}, {
  name: 'Valeria S.',
  place: 'Neuquén',
  minutesAgo: 14
}, {
  name: 'Matías L.',
  place: 'Salta',
  minutesAgo: 22
}, {
  name: 'Florencia B.',
  place: 'CABA',
  minutesAgo: 4
}, {
  name: 'Nicolás V.',
  place: 'Bahía Blanca, Buenos Aires',
  minutesAgo: 16
}];

// EJEMPLOS DE REDACCIÓN: reemplazá cada texto y nombre por testimonios reales (con permiso) antes de publicar.
export const testimonials: {
  name: string;
  role: string;
  place: string;
  quote: string;
  photo: string;
  photoAlt: string;
}[] = [{
  name: 'Romina A.',
  role: 'Personal Trainer',
  place: 'Córdoba',
  quote: 'Ahora armo las sesiones de mis alumnos mayores en minutos. Las progresiones del módulo 3 me ordenaron muchísimo el trabajo de fuerza.',
  photo: 'https://cdn.magicpatterns.com/uploads/hBVodMNkG2naLGE5GGBL6d/WhatsApp_Image_2026-09-25_at_00.17.09.jpg',
  photoAlt: 'Alumna adulta mayor haciendo remo con banda elástica en el gimnasio'
}, {
  name: 'Martín G.',
  role: 'Profesor de Educación Física',
  place: 'Rosario, Santa Fe',
  quote: 'Tenía conocimientos de entrenamiento pero me faltaban actividades específicas. Las propuestas con conos y aros las uso todas las semanas.',
  photo: 'https://cdn.magicpatterns.com/uploads/rfYVXjuAXLDsba93T24Fxb/WhatsApp_Image_2026-09-22_at_13.28.32_(1).jpg',
  photoAlt: 'Adulta mayor haciendo un circuito de coordinación con conos y aro en un patio'
}, {
  name: 'Silvia R.',
  role: 'Acompañante terapéutica',
  place: 'La Plata, Buenos Aires',
  quote: 'Trabajo a domicilio y con el adaptador de ejercicios puedo ajustar cada actividad según cómo esté la persona ese día. Muy práctico.',
  photo: 'https://cdn.magicpatterns.com/uploads/sCFMCXxvVArNP1yTx1TqGf/WhatsApp_Image_2026-09-22_at_13.06.20.jpg',
  photoAlt: 'Adulta mayor sentada haciendo un ejercicio con banda elástica en su casa'
}, {
  name: 'Laura M.',
  role: 'Profesora de Educación Física',
  place: 'Mendoza',
  quote: 'Las actividades de estimulación cognitiva + movimiento hacen que las clases sean mucho más dinámicas. Mis alumnas se enganchan un montón.',
  photo: 'https://cdn.magicpatterns.com/uploads/jT4ziCW96sm9fZVqa6TskD/WhatsApp_Image_2026-09-22_at_13.28.32.jpg',
  photoAlt: 'Adulta mayor con una pelota haciendo un juego de aros y conos en el piso'
}, {
  name: 'Carolina P.',
  role: 'Personal Trainer',
  place: 'CABA',
  quote: 'Empecé a trabajar con adultos mayores hace poco y esto me dio una base clara para planificar. Las sesiones express me salvan cuando tengo poco tiempo.',
  photo: 'https://cdn.magicpatterns.com/uploads/oPsg8D7nPMZweMWVgWEe1Z/WhatsApp_Image_2026-09-25_at_00.17.10_(1).jpg',
  photoAlt: 'Entrenadora mostrando un ejercicio con mancuernas a una alumna adulta mayor'
}, {
  name: 'Graciela F.',
  role: 'Instructora en centro de día',
  place: 'Mar del Plata, Buenos Aires',
  quote: 'Uso las planillas del kit profesional para registrar asistencia y evolución del grupo. Todo queda mucho más organizado.',
  photo: 'https://cdn.magicpatterns.com/uploads/kiQ7tNmWSCYmqmdi1H4r3v/WhatsApp_Image_2026-09-25_at_00.17.10.jpg',
  photoAlt: 'Adulta mayor sonriente levantando mancuernas en una clase'
}];
export const trustItems: string[] = ['Pago seguro.', 'Acceso digital.', 'Entrega inmediata.', 'Compatible con celular, tablet y computadora.', '7 días de garantía.'];
export const faqs: {
  question: string;
  answer: string;
}[] = [{
  question: '¿Puedo utilizarlo si recién estoy empezando?',
  answer: 'Sí. El contenido está organizado desde las bases hasta la planificación y aplicación de propuestas, por lo que puede servir como punto de partida para quienes quieren incorporar este campo a su perfil.'
}, {
  question: '¿Es un curso?',
  answer: 'REACTIVA TU CUERPO™ es una preparación práctica y biblioteca digital de recursos organizada en 7 módulos, con ejercicios, actividades, rutinas, planificación y herramientas complementarias.\n\nNo se presenta como una certificación oficial ni reemplaza una formación profesional habilitante cuando esta sea necesaria.'
}, {
  question: '¿Desde dónde puedo acceder?',
  answer: 'Podés acceder desde celular, tablet o computadora.'
}, {
  question: '¿Cuándo recibo el producto?',
  answer: 'El acceso es digital e inmediato después de completar la compra.'
}, {
  question: '¿El pago es único?',
  answer: 'Sí. Realizás un único pago de $19.990 y recibís acceso al contenido incluido en la oferta.'
}, {
  question: '¿Tiene garantía?',
  answer: 'Sí. Tenés 7 días de garantía desde tu compra. Si REACTIVA TU CUERPO™ no es lo que esperabas, escribinos a armatedigitalsoporte@gmail.com dentro de ese plazo y te devolvemos el dinero.'
}];